import HeaderTop from 'themes/base/components/shop/HeaderTop'

export default {
  extends: HeaderTop,
}
